export enum EQueryType {
	QUERY_BUILDER = 'builder',
	CLICKHOUSE = 'clickhouse_sql',
	PROM = 'promql',
}
